import { ToolExecutionHarPayloadSchema } from '@terra/api-proxy-dtos';
import { defineSseEvent } from '@terra/shared-sse-contracts';
import { z } from 'zod';

export const ToolHarSsePayloadSchema = ToolExecutionHarPayloadSchema.extend({
  targetType: z.string(),
  emittedAt: z.number(),
});

export const TOOL_EXECUTION_HAR_SSE_EVENT = defineSseEvent({
  type: 'tool_execution_har',
  payload: ToolHarSsePayloadSchema,
  channelPrefix: 'tool-har',
  channelKey: ({ executionId, toolCallId, emittedAt }) =>
    `${executionId}:${toolCallId}:${emittedAt}`,
  target: {
    type: ({ targetType }) => targetType,
    id: ({ applicationId }) => applicationId,
  },
});

export type ToolHarSsePayload = z.infer<typeof ToolHarSsePayloadSchema>;
